export default "__VITE_ASSET__4y7tJjd3__"